export default {
  'earn': 'Earn',
  'earn.title': 'Hold and earn interest with Biconomy Earn',
  'earn.desc': 'Hold money to earn interest. We make earning simple and straightforward helping you enhance your financial security.',
  'earn.stats': 'Earning Stats',
  'earn.my': 'My Earnings',
  'earn.total_dep': 'Total Deposited',
  'earn.total_earn': 'Total Earnings',
  'earn.log_tip': 'Log in to view holding details',
  'earn.product': 'Earning Products',
  'earn.est_rate': 'Est. Rate (APR)',

  // 购买弹窗
  'earn.schedule_1': 'Subscription',
  'earn.schedule_2': 'Interest accrual',
  'earn.schedule_3': 'Interest distribution',
  'earn.schedule_4': 'Expiration',
  'earn.schedule_5': 'Redemption period',
  'earn.schedule_6': 'Arrival date',
  'earn.confirm_1': 'Subscription Amount',
  'earn.confirm_2': 'Est. Interest',

  // 赎回弹窗
  'earn.redeem.confirm': 'I confirm the following',
  'earn.redeem.successful': 'Successful Redemption',
  'earn.redeem.back': 'Back to Biconomy Earn',
  'apy.current': 'Current APY',
  'redeeming': 'Redeeming',
  'redemption_amount': 'Redemption Amount',
  'settlement_time': 'Settlement Time',
  'received': 'Received',
  'redeemed_on': 'Redeemed on',

  'term': 'Term',
  'token': 'Token',
  'saving': 'Saving',
  'subscribe': 'Subscribe',
  'apy': 'Apy',
  'apr': 'APR',
  'types': 'Types',
  'apy_rate': 'Rate (APR)',
  'redeem': 'Redeem',
  'redemption': 'Redemption',

  'term.all': 'All Terms',
  'fixed': 'Fixed',
  'flexible': 'Flexible',

  'available_balance': 'Available Balance',
  'input.amount': 'Input Amount',
  'agree.conditions': 'I agree with the conditions',
  'schedule': 'Schedule',
  'progress': 'Progress',
  'earn.redeem.tip':
    'Suppose you initiate a premature withdrawal in a term deposit. In that case, our system will deduct all the profits you obtained from the order. Redemption amount=subscription amount-total profit.',
  'Savings': 'Savings',
  'promotions': 'Promotions',
  'Reference APR': 'Reference APR',

  'earn_less_min': 'Less than the minimum subscription amount',
  'earn_Insufficient_subscription': 'Insufficient subscription amount',
  'earn_Insufficient_redeemable': 'Insufficient redeemable amount',

  'earn_product': "Earn Product",
  'cumulative_profit': 'Cumulative Profit',
  'last_day_pnl': 'Last Day PNL',

  "Duration": "Duration",
  "Advanced": "Advanced",
  "Steady": "Steady",
  "all_products_type": "All Products Type",
  "product_type": "Product type",
  "all_products": "All Products"
};
